export const HEALTH_STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'good', label: 'Good' },
  { value: 'needs_attention', label: 'Needs attention' },
  { value: 'problem', label: 'Problem' },
];

export const PUNCTUALITY_STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'green', label: 'On time' },
  { value: 'amber', label: 'Borderline' },
  { value: 'red', label: 'Late' },
  { value: 'not_started', label: 'Not started' },
];

export function weekMondayForDate(ymd) {
  const d = new Date(`${ymd}T12:00:00+05:30`);
  const day = d.getUTCDay();
  const diff = day === 0 ? -6 : 1 - day;
  d.setUTCDate(d.getUTCDate() + diff);
  return d.toISOString().slice(0, 10);
}

export function weekEndForStart(weekStart) {
  const d = new Date(`${weekStart}T12:00:00+05:30`);
  d.setDate(d.getDate() + 6);
  return d.toISOString().slice(0, 10);
}

export function isDateInWeek(dateYmd, weekStart, weekEnd) {
  if (!dateYmd || !weekStart || !weekEnd) return false;
  return dateYmd >= weekStart && dateYmd <= weekEnd;
}

export function filterByTeacher(rows, teacherId, key = 'teacherId') {
  if (!teacherId) return rows;
  return rows.filter((r) => String(r[key]) === String(teacherId));
}

/** Class-start rows: match cover teacher, original batch teacher, or secondary. */
export function filterClassStartByTeacher(rows, teacherId) {
  if (!teacherId) return rows;
  const id = String(teacherId);
  return rows.filter(
    (r) =>
      String(r.teacherId) === id ||
      String(r.originalTeacherId || '') === id ||
      String(r.secondaryTeacherId || '') === id
  );
}

export function filterByHealthStatus(rows, status) {
  if (!status) return rows;
  return rows.filter((r) => r.status === status);
}

export function filterByPunctualityStatus(rows, status) {
  if (!status) return rows;
  return rows.filter((r) => r.punctualityStatus === status);
}

export function filterBySessionDate(rows, dateYmd) {
  if (!dateYmd) return rows;
  return rows.filter((r) => r.sessionDate === dateYmd);
}

export function summarizeBatchHealth(batches) {
  return {
    total: batches.length,
    good: batches.filter((r) => r.status === 'good').length,
    needsAttention: batches.filter((r) => r.status === 'needs_attention').length,
    problem: batches.filter((r) => r.status === 'problem').length,
  };
}

export function summarizeClassStart(items) {
  return {
    total: items.length,
    green: items.filter((i) => i.punctualityStatus === 'green').length,
    amber: items.filter((i) => i.punctualityStatus === 'amber').length,
    red: items.filter((i) => i.punctualityStatus === 'red').length,
    notStarted: items.filter((i) => i.punctualityStatus === 'not_started').length,
  };
}

export function buildWeeklyReportParams(weekStart, filterDate) {
  const params = { weekStart };
  if (filterDate) params.date = filterDate;
  return params;
}
